import { addDoubleQuotes, isNumber } from '../utils/smartutils';

function getChildren(values) {
  const children = values.map(
    (item) =>
      `{
            id: ${item.id ? item.id : 0},
            cycle: ${item.cycle ? item.cycle : 0},
            type: ${item.type ? item.type : null},
            justification: ${addDoubleQuotes(item.justification)}
            schoolClass: {
                          id: ${item.schoolClass.id ? item.schoolClass.id : 0},
                          active: true,
                          year: 0,
                          studentsQuantity: 0,
                          filterByStatus: false,
                          updaterId: 0,
                          capacity: 0
                      },
          courseStep: {                          
              id: ${item.courseStep.id ? item.courseStep.id : 0},
              cycleQuantity: 0
          }
          subject: {
              id: ${item.subject.id ? item.subject.id : 0},
              active: true,
              termFilterId: 0,
              subjectLevelFilterId: 0,
              filterByStatus: false,
              updaterId: 0
          },
          student: {
              id: ${item.student.id ? item.student.id : 0},
              filterByStatus: false, 
              updaterId: 0 ,
              active: true ,
              activeOnLoggedPeriod: true,
              legacyId: 0,
              dateOfBirth: 0
          },
          dateInMilli: ${item.date.getTime()}
        }`
  );
  return children.join(',');
}

export function saveStudentAttendanceAll(values) {
  const mutation = `
    mutation {
        saveStudentAttendanceAll(
          studentAttendances: [
              ${getChildren(values)}
          ]),
        {id}
    }`;
  return mutation;
}

export function findStudentAttendanceForClassDiary(
  dateInMilli,
  classId,
  subjectId,
  classSequences
) {
  return `
  {
      listStudentAttendanceForClassDiary(
        dateInMilli: ${dateInMilli}, 
        classId: ${classId}, 
        subjectId: ${subjectId},
        classSequences: ${JSON.stringify(classSequences).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )}) {
          id,
          classSequence,
          attendanceType
          student {
              id
          }
      }
}`;
}

export function saveStudentAttendanceAllByClassDiary(values) {
  const studentAttendanceList = [];
  values.studentAttendance.forEach((student) => {
    Object.keys(student).forEach((key) => {
      let studentAttendance = {};
      if (isNumber(key) && !student[key].hidden) {
        studentAttendance = {
          id: student[key].id || 0,
          cycle: values.schoolClass.courseStep.course.id,
          attendanceType: student[key].attendanceType,
          justification: '',
          classSequence: student[key].classSequence,
          schoolClass: {
            id: values.schoolClass.id,
            active: true,
            year: 0,
            studentsQuantity: 0,
            filterByStatus: false,
            updaterId: 0,
            capacity: 0,
            academicCalendar: {
              id: values.schoolClass.academicCalendar.id,
            },
            courseStep: {
              id: values.schoolClass.courseStep.id,
              cycleQuantity: values.schoolClass.courseStep.cycleQuantity,
            },
          },
          subject: {
            id: values.subject.id,
            active: true,
            termFilterId: 0,
            subjectLevelFilterId: 0,
            filterByStatus: false,
            updaterId: 0,
          },
          student: {
            id: student.id,
            updaterId: 0,
            active: true,
            activeOnLoggedPeriod: true,
            legacyId: 0,
            dateOfBirth: 0,
          },
          dateInMilli: new Date(values.dateInMilli).getTime(),
        };
        studentAttendanceList.push(studentAttendance);
      }
    });
  });

  const mutation = `mutation {
    saveStudentAttendanceAll(
        studentAttendances: ${JSON.stringify(studentAttendanceList).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )}
        )
    , {id}
}`;
  return mutation;
}
